<template>
  <div class="passwordonboarding-container">
    <b-modal
      id="passwordonboardingModal"
      ref="passwordonboardingModal"
      header-bg-variant="dark"
      header-text-variant="light"
      :hide-footer="true"
      :hide-header-close="(!showClose)"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      size="lg"
      :title="modalTitle"
    >
      <b-container fluid>
        <div class="email-container">
          <b-form validate ref="passwordonboardingForm" @submit.stop.prevent="onSubmit">
            <b-form-group
              label="Seu email"
              description="Nossa comunicação é feita por email, sem spam."
            >
              <b-form-input
                type="email"
                v-model="form.email"
                required
                placeholder="informe seu email aqui"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Sua senha"
              description="Para acesso ao QUEOTA.club - apenas o primeiro acesso é via Steam ;)"
            >
              <b-form-input
                type="password"
                v-model="form.password"
                required
                placeholder="informe a senha desejada aqui"
              ></b-form-input>
            </b-form-group>

            <div class="actions">
              <b-button type="submit" size="lg" variant="success">Salvar senha</b-button>
            </div>
          </b-form>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Onboarding",
  props: {
    showClose: Boolean
  },
  data() {
    return {
      currentSlide: 0,
      form: {
        email: "",
        password: ""
      },
      modalTitle: "Escolha uma senha para acesso"
    };
  },
  methods: {
    initialize() {
      this.$refs.passwordonboardingModal.show();
      this.form.nickname = this.$store.getters.user.nickname;
    },
    onSubmit(e) {
      this.$http
        .put(`users/${this.$store.getters.user.id}.json`, { user: this.form })
        .then(response => {
          this.$store.dispatch("updateUserProfile", response.data);
          this.$notify({
            group: "all",
            title: "Seja bem-vindo oficialmente ao QUEOTA.club",
            type: "success"
          });
          this.$refs.passwordonboardingModal.hide();
        });
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>

<style lang="sass" scoped>
.actions
  text-align: center
  margin-top: 20px
</style>
